import IconComponent from "icons/IconComponent";

import DiscIcon from "./disc.svg";

export default (DiscIcon as any) as IconComponent;
